import { FC } from "react";

import PageHeading from "@/components/Core/PageHeading";
import { useTranslate } from "@/hooks";
import { usePageMeta } from "@/hooks/usePageMeta";

/** Title, description and h1 of an in-house game page; the crawler head says the same (backend modules/seo). */
const OriginalMeta: FC<{ name: string }> = ({ name }) => {
  const t = useTranslate();
  usePageMeta({ title: name, description: t("seo.play-game", { name }) });
  return <PageHeading text={name} />;
};

export default OriginalMeta;
